module.exports = {"name":"CDS","parameters":[{"name":"enableCourseItemCoverRedesign","valid":["control","test"],"value":"control"}]}